import React from 'react';

const DeepSeekMoment = () => (
  <article className="news-article-body">
    <p className="news-lead">
      On January 20, 2025, a Chinese AI startup called DeepSeek released a reasoning model
      called R1 - and wiped roughly $600 billion off NVIDIA's market cap in a single day.
      It was the largest single-day market cap loss in US stock market history. Not bad for
      a model that reportedly cost $5.6 million to train.
    </p>

    <h2>What DeepSeek R1 actually was</h2>
    <p>
      R1 is a reasoning model - meaning it "thinks" through problems step-by-step before
      answering, similar to OpenAI's o1. In tests, it matched o1's performance on maths,
      coding, and science tasks. And critically, DeepSeek released the model weights openly -
      anyone could download and run it for free.
    </p>
    <p>
      The reported training cost? Around $5.6 million. For comparison, OpenAI's GPT-4 was
      estimated to have cost over $100 million to train. Whether DeepSeek's figure accounts
      for all their research costs is still debated - but the direction was unmistakable.
      You could build frontier AI for a fraction of what Silicon Valley assumed.
    </p>

    <h2>Why markets panicked</h2>
    <p>
      The whole bull case for NVIDIA rested on a simple idea: building competitive AI requires
      enormous spending on chips. The more AI companies spend, the more GPUs they buy,
      the higher NVIDIA's revenues.
    </p>
    <p>
      DeepSeek challenged that assumption directly. If a Chinese startup could match OpenAI's
      best model at a tiny fraction of the compute cost, maybe the industry didn't need to
      buy as many chips as everyone thought. Markets drew the obvious conclusion and sold first.
    </p>
    <ul>
      <li><strong>NVIDIA:</strong> -17%, approximately $600 billion wiped in one session</li>
      <li><strong>Google, Amazon, Microsoft, Tesla:</strong> All dropped significantly</li>
      <li><strong>DeepSeek app:</strong> Hit #1 on the US App Store, briefly beating ChatGPT</li>
    </ul>

    <h2>The "Sputnik moment" comparison</h2>
    <p>
      A lot of people compared it to Sputnik in 1957 - the Soviet satellite launch that
      shocked America into action. The parallel is that a competitor suddenly demonstrated
      something everyone assumed was beyond their reach.
    </p>
    <p>
      The comparison has limits though. DeepSeek didn't keep their model secret - they
      published it openly and shared their techniques. It was more of a scientific achievement
      anyone could build on than a strategic threat. But the psychological effect on the
      US tech industry was very real.
    </p>

    <h2>What actually happened next</h2>
    <p>
      NVIDIA's stock recovered within weeks. By mid-2025, NVIDIA became the first company
      to hit a $5 trillion market cap. The reasoning: cheaper inference means more AI adoption,
      which means more demand for training new models, which means more NVIDIA chips.
    </p>
    <p>
      But the lasting change was in how AI labs think about efficiency. DeepSeek validated
      techniques like <strong>model distillation</strong> (learning from a bigger model),
      <strong>sparse mixture-of-experts architectures</strong>, and
      <strong>reinforcement learning from verifiable rewards</strong> - all of which DeepSeek
      used extensively. Every lab started looking harder at algorithmic efficiency, not
      just raw compute.
    </p>

    <div className="news-insight-box">
      <h3>The big lesson</h3>
      <p>
        Smart algorithms can substitute for raw compute. DeepSeek proved that assuming any
        single actor has a permanent lead in AI is dangerous. And by releasing R1's weights
        openly, they handed every researcher in the world a frontier reasoning model to
        build on. That might have been the biggest impact of all.
      </p>
    </div>
  </article>
);

export default DeepSeekMoment;
